export default {
  zh: {
    translation: {},
  },
  en: {
    translation: {},
  },
};